const galleryData = [
  {
    id: 1,
    image: "/images/gallery/gallery1.jpg",
    title: "Basketball Court",
    location: "Hyderabad",
    category: "Basketball",
    surface: "Acrylic Court",
  },

  {
    id: 2,
    image: "/images/gallery/gallery2.webp",
    title: "Tennis Court",
    location: "Hyderabad",
    category: "Tennis",
    surface: "Acrylic Court",
  },

  {
    id: 3,
    image: "/images/gallery/gallery3.webp",
    title: "Football Turf",
    location: "Hyderabad",
    category: "Football",
    surface: "Artificial Turf",
  },

  {
    id: 4,
    image: "/images/gallery/gallery4.webp",
    title: "Running Track",
    location: "Hyderabad",
    category: "Running Track",
    surface: "EPDM Track",
  },

  {
    id: 5,
    image: "/images/gallery/gallery5.webp",
    title: "Badminton Court",
    location: "Hyderabad",
    category: "Badminton",
    surface: "PVC Flooring",
  },

  {
    id: 6,
    image: "/images/gallery/gallery6.webp",
    title: "Pickleball Court",
    location: "Hyderabad",
    category: "Pickleball",
    surface: "Acrylic",
  },

  {
    id: 7,
    image: "/images/gallery/gallery7.webp",
    title: "Multipurpose Court",
    location: "Hyderabad",
    category: "Basketball",
    surface: "PU Surface",
  },

  {
    id: 8,
    image: "/images/gallery/gallery8.webp",
    title: "Tennis Academy",
    location: "Hyderabad",
    category: "Tennis",
    surface: "Synthetic Acrylic",
  },
];

export default galleryData;
